<template>
    <div id="dispatchLook">
        <el-col class="searthPart" style="width: 100%;padding-top:10px">
            <div class="order-content">
                <div class="clearfix">
                    <el-form :inline="true" :model="orderForm" class="demo-form-inline clearfix">
                        <el-form-item label="详细地址：">
                            <el-input v-model.trim="orderForm.address" clearable placeholder="请输入详细地址"></el-input>
                        </el-form-item>                
                        <el-form-item label="单号：">
                            <el-input v-model.trim="orderForm.orderNo" clearable placeholder="请输入单号"></el-input>
                        </el-form-item>                
                        <el-form-item>
                            <el-button type="success" size="small" @click="selectWorkOrder">查询</el-button>
                        </el-form-item>
                        <i class="fr el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
                    </el-form>                    
                </div>
                
                <el-table
                    :data="returnData"
                    border
                    ref="singleTable"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%;"
                    class="siggle-select-content"
                    highlight-current-row
                    @current-change="handleCurrentSingleChange">
                    <el-table-column
                        align="center"
                        width="50">
                        <template slot-scope="scope">
                            <el-checkbox @change="handleCurrentSingleChange(scope.row)" v-model="scope.row.selected" :checked="scope.row.selected"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="设备详情">
                        <template slot-scope="scope">
                            <span>{{scope.row.modelName}} {{scope.row.colorName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        label="订单类型">
                        <template slot-scope="scope">
                            {{ scope.row.serviceType | sysCodeFileter('order_type') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="120"
                        align="center"                    
                        label="订单渠道">
                        <template slot-scope="scope">
                            {{ scope.row.orderIdentifier | sysCodeFileter('order_identifier') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        sortable
                        label="区域">
                        <template slot-scope="scope">
                           {{scope.row.countyName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="地址">
                        <template slot-scope="scope">
                            {{scope.row.address}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="totalAp"
                        label="故障小类">
                        <template slot-scope="scope"> 
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassShortName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="预约时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.onsiteDate }} {{scope.row.onsiteTimeStart}}~{{scope.row.onsiteTimeEnd}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="220"
                        align="center"
                        prop="orderNo"                     
                        label="订单号">
                    </el-table-column>
                </el-table>
            </div>
            <el-form :inline="true" ref="engineerForm" :model="engineerForm" class="demo-form-inline">
                <el-form-item label="维修状态：">
                    <el-select @change="selectEngineerStatus" v-model="engineerForm.maintenceStatus" placeholder="请选择工程师维修状态" clearable filterable>
                        <el-option v-for="(item,index) in pickingEngineerStatus" 
                            :label="item.paraName" 
                            :value="item.paraValue" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>                
                <el-form-item class="item-click-content">
                    <el-button type="default" @click="mtClick" :class="{'active':engineerForm.isQueryMt == 1}">技能匹配</el-button>
                </el-form-item>
                <el-form-item class="item-click-content">
                    <el-button type="default" @click="pmClick" :class="{'active':engineerForm.isQueryPm == 1}">背包匹配</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 100%;">
            <el-card class="box-card item-click-content">
                <el-button v-for="(item,index) in pickingEngineerList" :class="{'active':item.isMatch == 1}" :key="index" size="small" @click="newModel(item.id)">{{item.name}}</el-button>
            </el-card>
            <el-dialog :visible.sync="dislogModel" custom-class="showTable" :close-on-click-modal="false" width="1100px" :modal-append-to-body="false"  @close="emptyModelDialog" :show-close="false">
                <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="订单列表" name="first">
                        <el-table
                            :data="engineerOrderList"
                            border
                            :header-cell-style="{'text-align':'center'}"
                            style="width: 100%;">
                            <el-table-column
                                width="100"
                                align="center"                    
                                label="订单渠道">
                                <template slot-scope="scope">
                                    {{ scope.row.orderIdentifier | sysCodeFileter('order_identifier') }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="120"
                                align="center"
                                prop="modelName"                     
                                label="机型">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="180"
                                label="故障">
                                <template slot-scope="scope"> 
                                    <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassShortName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="onsiteDate"
                                width="100"
                                label="预约日期">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="120"
                                label="预约时间">
                                <template slot-scope="scope">
                                    <span>{{scope.row.onsiteTimeStart}}~{{scope.row.onsiteTimeEnd}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="80"
                                label="区域">
                                <template slot-scope="scope">
                                    {{scope.row.countyName}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="150"
                                label="地址">
                                <template slot-scope="scope">
                                    {{scope.row.address}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="120"
                                align="center"
                                prop="payTime"                     
                                label="完成时间">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.payTime">{{scope.row.payTime | date}}</span>
                                </template>
                            </el-table-column>
                             <el-table-column
                                width="120"
                                align="center"                    
                                label="完成度">
                                <template slot-scope="scope">
                                    {{scope.row.adminStatus | sysCodeFileter('admin_status')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="180"
                                align="center"
                                prop="orderNo"                     
                                label="订单号">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="库存列表" name="second">
                        <el-table
                            :data="engineerInventoryList"
                            border
                            :header-cell-style="{'text-align':'center'}"
                            style="width: 100%;">
                            <el-table-column
                                width="180"
                                align="center"
                                prop="modelName"                     
                                label="型号">
                                <template slot-scope="scope">
                                    <span>{{scope.row.modelName}} {{scope.row.colorName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                width="180"
                                prop="materialName"
                                label="物料名称">
                            </el-table-column>
                            <el-table-column
                                width="180"
                                align="center"
                                prop="materialCode"                     
                                label="物料编码">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="warehouseType"
                                label="仓库类型">
                            </el-table-column>
                            <el-table-column
                                width="180"
                                align="center"
                                prop="name"                     
                                label="工程师名称">
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="sum2"                     
                                label="数量">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <span slot="footer" class="dialog-footer" style="text-align: center">
                    <el-button type="default" @click="dislogModel = false">关闭</el-button>
                </span>
            </el-dialog>
        </el-col>
    </div>
</template>

<script>
    import {selectWorkOrder,queryEngineerKb,queryEngineerOrderList,engineerInventoryList } from "../../api/order";
    import {selectParameterInfoBusiness} from "@/api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'dispatchLook',
        data () {
            return {
                pickingEngineerList:[],
                pickingEngineerStatus:[],
                engineerOrderList:[],
                engineerInventoryList:[],
                labelPosition:'left',
                orderForm:{
                    orderNo:'',
                    address:'',
                    adminStatusList:['03','38']
                },
                returnData: [],
                dislogModel:false,
                activeName: 'first',
                currentRow:null,
                engineerForm:{
                    maintenceStatus:'', //维修状态
                    isQueryMt: 0,       //维修技能
                    isQueryPm: 0,       //匹配背包
                    brandId:'',
                    categoryId:'',
                    modelId:'',
                    colorId:'',
                    faultSubclass:[]
                },
                engineerOrderForm:{
                    engineerId:'',
                    complateStatus:'0'
                },
                modelForm:{
                    warehouseType:'LPC',
                    belonger:''
                },
                basicsAuth:{
                    revert_send_orders:false
                }

            }
        },
        mounted () {
            this.basicsAuth.revert_send_orders= getPermission('/api/workOrder/order/revert_send_orders');
        },
        created(){
            this.engineerListData();
            this.queryEgineerStatus();
        },
        methods: {
            handleCurrentSingleChange(val) {
                this.currentRow = val;
                this.returnData.forEach((item,index)=>{
                    item.selected = (item.id != val.id) ? false : true;
                });
            },
            handleClick(tab, event) {
                //console.log(tab, event);
            },
            //技能匹配
            mtClick(e){
                if(!this.orderForm.address && !this.orderForm.orderNo){
                    this.$message({
                        message: '请先输入地址或订单号查询订单',
                        type: "warning"
                    });
                    return
                }
                if(this.returnData.length == 0){
                    this.$message({
                        message: '当前没有可匹配的订单号',
                        type: "warning"
                    });
                    return
                }
                this.engineerForm.isQueryMt = this.engineerForm.isQueryMt == 0 ? 1 : 0;
                this.engineerListData();
            },
            //背包匹配
            pmClick(e){
                if(!this.orderForm.address && !this.orderForm.orderNo){
                    this.$message({
                        message: '请先输入地址或订单号查询订单',
                        type: "warning"
                    });
                    return
                }
                if(this.returnData.length == 0){
                    this.$message({
                        message: '当前没有可匹配的订单号',
                        type: "warning"
                    });
                    return
                }
                this.engineerForm.isQueryPm = this.engineerForm.isQueryPm == 0 ? 1 : 0;
                this.engineerListData();
            },
            //获取工程师维修状态列表
            queryEgineerStatus(){
                selectParameterInfoBusiness({paraType:'engineer_maintence_status'}).then(res => {
                    if (res.data.status==100) {
                        this.pickingEngineerStatus = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选择工程师状态
            selectEngineerStatus(e){
                if(e != null){
                    this.engineerListData();
                }
            },
            //获取工程师列表
            engineerListData(){
                if(this.currentRow != null){
                    this.engineerForm.brandId = this.currentRow.brandId;
                    this.engineerForm.categoryId = this.currentRow.categoryId;
                    this.engineerForm.modelId = this.currentRow.modelId;
                    this.engineerForm.colorId = this.currentRow.colorId;
                    this.engineerForm.faultSubclass = this.currentRow.faultSubclass;
                    this.engineerForm.provinceId = this.currentRow.province;
                    console.log(this.currentRow)
                }
                queryEngineerKb(this.engineerForm).then(res => {
                    if (res.data.status==100) {
                        this.pickingEngineerList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师订单列表
            engineerOrderListData(){
                this.engineerOrderForm.startRow = 1;
                this.engineerOrderForm.pageSize = 10000;
                queryEngineerOrderList(this.engineerOrderForm).then(res => {
                    if (res.data.status==100) {
                        this.engineerOrderList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师库存列表
            engineerInventoryListData(){
                this.modelForm.startRow = 1;
                this.modelForm.pageSize = 10000;
                engineerInventoryList(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.engineerInventoryList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
            },
            //查看工程师订单&库存
            newModel(id) {
                this.engineerOrderForm.engineerId = id;
                this.modelForm.belonger = id;
                this.engineerOrderListData();
                this.engineerInventoryListData();
                this.dislogModel = true;
            },
            //查询订单
            selectWorkOrder(){
                this.returnData = [];
                if(!this.orderForm.address && !this.orderForm.orderNo){
                    this.$message({
                        message: '请输入地址或订单号再查询',
                        type: "warning"
                    });
                    return
                }
                selectWorkOrder(this.orderForm).then(res => {          
                    if (res.data.status==100) {
                        res.data.results.list.forEach((item,index)=>{
                            item.selected = (index == 0) ? true : false;
                            item.countyName = item.countyName ? item.countyName : '';
                        })           
                        this.returnData = res.data.results.list;
                        if(this.returnData.length > 0){
                            this.$refs.singleTable.setCurrentRow(this.returnData[0]);
                            this.currentRow = this.returnData[0];
                        }else{
                            this.currentRow = null;
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //刷新
            refresh() {
                this.engineerListData();
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #dispatchLook{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        .showTable{
            .el-dialog__header{
                padding:0
            }
        }
        .item-click-content{
            text-align:left;
            .el-button{
                margin-bottom:20px
            }
            .active{
                color: #FFF;
                background-color: #409EFF;
                border-color: #409EFF;
            }
        }
        .order-content{
            padding-bottom:50px;
            border-bottom:1px dashed #999;
            margin-bottom:50px;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .shiftTime{
            li{
                display:inline-block;
                margin-right:10px;
                font-size:14px;
                color:#666;
                margin-bottom:15px;
                cursor:pointer
            }
            li:nth-child(1){
                margin-right:5px;
                cursor:default
            }
            li.active{
                color:#409EFF
            }
        }
        .el-dialog__footer{
            text-align:center !important
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// dispatchLook.vue?f9098b6e